import { useFormik } from "formik";
import BoardTextInput from "../../../../components/inputs/dashboardTextInput";
import BoardSelect from "../../../../components/select/dashboardSelect";
import BoardButton from "../../../../components/buttons/boardButton";

const EditEmployee = ({ t, selected }) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: selected?.name || "",
      email: selected?.email || "",
      phone: selected?.phone || "",
      status: selected?.status || "active",
    },
    onSubmit: (values) => {
      console.log("Updated Employee:", values);
    },
  });

  const handleCancel = () => {
    formik.resetForm(); // Reset to initial selected values
  };

  const statusOptions = [
    { label: t("active"), value: "active" },
    { label: t("notActive"), value: "not_active" },
  ];

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="max-w-xl p-4 mx-auto space-y-5 bg-white dark:bg-gray-900 rounded-xl"
    >
      <BoardTextInput
        formik={formik}
        label={t("name")}
        name="name"
        placeholder={t("enterName")}
      />
      <BoardTextInput
        formik={formik}
        label={t("email")}
        name="email"
        placeholder={t("enterEmail")}
      />
      <BoardTextInput
        formik={formik}
        label={t("phone")}
        name="phone"
        placeholder={t("enterPhone")}
      />
      <BoardSelect
        formik={formik}
        name="status"
        options={statusOptions}
        label={t("status")}
        placeholder={t("select")}
      />
      <div className="flex flex-wrap items-center gap-4 md:flex-nowrap">
        <BoardButton
          type="button"
          onClick={handleCancel}
          secondary
          bg
          className="w-full"
        >
          {t("cancel")}
        </BoardButton>
        <BoardButton type="submit" primary bg className="w-full">
          {t("save")}
        </BoardButton>
      </div>
    </form>
  );
};

export default EditEmployee;
